import {lazy} from 'react';

const RELOAD_FLAG_PREFIX = 'chunk-reload:';

// After a new deploy, a route chunk fetched by its old hashed filename can
// 404 for tabs left open across the deploy. Reload once per chunk instead of
// showing a generic error, since a fresh page load will resolve the new hash.
export const lazyWithRetry = (componentImport, chunkId) =>
  lazy(async () => {
    try {
      return await componentImport();
    } catch (error) {
      const isChunkLoadError =
        error?.name === 'ChunkLoadError' ||
        /Failed to fetch dynamically imported module|Loading chunk .* failed|error loading dynamically imported module/i.test(
          error?.message ?? ''
        );

      const reloadFlagKey = `${RELOAD_FLAG_PREFIX}${chunkId}`;
      if (isChunkLoadError && !localStorage.getItem(reloadFlagKey)) {
        localStorage.setItem(reloadFlagKey, '1');
        window.location.reload();
        // Never resolves; the reload takes over before this matters.
        return new Promise(() => {});
      }

      throw error;
    }
  });
